import Vue from 'vue'
import iview from 'iview'

// import '@/styles/plugins/iview.less'
// import '@/styles/plugins/animate.less'

const { LoadingBar, Message, Modal, Notice, Spin } = iview

Object.keys(iview).forEach(key => {
    // 如果存在render函数或者props参数，则认为是个vue组件
    if (iview[key].render || iview[key].props) {
        Vue.component('i-' + key, iview[key])
    }
})

Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal
Vue.prototype.$Notice = Notice
Vue.prototype.$Spin = Spin

// 消息弹出框存在时长
Message.config({ duration: 3 })

// 全局loading模态框
Vue.prototype.$loading = function(
    flag = false,
    html = 'Loading',
    { maskClosable, closeBack } = {}
) {
    if (flag) {
        this.$Spin.show({
            render: h => {
                return h('div', [
                    h('i-Icon', {
                        class: 'loading',
                        props: {
                            type: 'ios-loading',
                            size: 40
                        }
                    }),
                    h('div', {
                        domProps: {
                            innerHTML: html
                        },
                        style: {
                            fontSize: '20px'
                        }
                    })
                ])
            }
        })
        // 遮罩关闭
        if (maskClosable) {
            const el = document.querySelector('body>div.ivu-spin-fullscreen')
            if (el) {
                el.onclick = () => {
                    this.$Spin.hide()
                    // 关闭回调事件
                    if (closeBack) {
                        setTimeout(() => {
                            closeBack()
                        }, 0)
                    }
                }
            }
        }
    } else {
        this.$Spin.hide()
    }
}
